import { Toggle } from "tailwindcss-stimulus-components"


// Connects to data-controller="toggle"
export default class extends Toggle {
  toggleSidebar() {
    document.querySelector('[data-controller="sidebar"]')['sidebar'].toggleSidebar();
  }
}
